
/* eslint-disable no-undef */
export default {
}
